// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"2dbeff3e","592":"135976e3"}[chunkId] + ".chunk.js";
};